import React, {
  createContext,
  useContext,
  useState,
  useReducer,
  useEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import {
  updateEmail,
  updatePassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth, fs, db } from "../firebase";
import { updateProfile } from "firebase/auth";
import { deleteDoc, serverTimestamp, doc } from "firebase/firestore";
import firebase from "firebase/compat/app";

const StateContext = createContext();

const DataContext = createContext();

function DataProvider({ children }) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [checked, setChecked] = useState(localStorage.getItem("switch"));
  const [pageLoading, setPageLoading] = useState(false);
  const [userCartProduct, setUserCartProduct] = useState([]);
  const [fullName, setFullName] = useState("");
  const [isDark, setIsDark] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [messsage, setMessage] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [signInErrorMsg, setSignInErrorMsg] = useState("");
  const [forgotErrorMsg, setForgotErrorMsg] = useState("");
  const [succedEmailSent, setSuccedEmailSent] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [admin, setAdmin] = useState(
    () => localStorage.getItem("admin") !== null
  );
  useEffect(() => {
    localStorage.setItem("admin", JSON.stringify(admin));
  }, [admin]);

  const [authed, setAuthed] = useState(
    () => localStorage.getItem("authed") !== null
  );
  //
  useEffect(() => {
    localStorage.setItem("authed", JSON.stringify(authed));
  }, [authed]);
  //

  function GetCurrentUser() {
    const [currentUser, setCurrentUser] = useState("");

    useEffect(() => {
      auth.onAuthStateChanged((currentUser) => {
        setCurrentUser(currentUser);
      });
    }, []);
    return currentUser;
  }
  const currentUser = GetCurrentUser();

  function GetUserUid() {
    const [currentUserId, setCurrentUserId] = useState(null);
    useEffect(() => {
      auth.onAuthStateChanged((currentUser) => {
        if (currentUser) {
          setCurrentUserId(currentUser.uid);
        }
      });
    }, []);

    return currentUserId;
  }
  const currentUserId = GetUserUid();
  function GetcurrentUserName() {
    const [currentUserName, setCurrentUserName] = useState(null);

    useEffect(() => {
      auth.onAuthStateChanged((currentUser) => {
        if (currentUser) {
          setCurrentUserName(currentUser.displayName);
        } else {
          setCurrentUserName(null);
        }
      });
    }, []);
    return currentUserName;
  }
  const currentUserName = GetcurrentUserName();

  const handleSignup = async (e) => {
    e.preventDefault();
    if (password !== rePassword) {
      return setErrorMsg("Passwords do not match");
    }
    try {
      setMessage("");
      setErrorMsg("");
      setPageLoading(true);

      await auth
        .createUserWithEmailAndPassword(email, password)
        .then(async (credential) => {
          const user = credential.user;

          await user.updateProfile({
            displayName: fullName,
          });
          await fs.collection("users").doc(user.uid).set({
            Email: email,
            Password: password,
            displayName: fullName,
            phoneNumber: data.Phonenumber,
            Address: data.Address,
            Country: data.Country,
            timeStamp: serverTimestamp(),
          });
        });

      navigate("/");
      window.location.reload();
    } catch (e) {
      setErrorMsg(e.message);
    }
    setPageLoading(false);
  };
  const handleAdd = async (e) => {
    e.preventDefault();
    if (password !== rePassword) {
      return setErrorMsg("Passwords do not match");
    }
    if (
      fullName === "" ||
      email === "" ||
      password === "" ||
      data.Address === "" ||
      data.Country === "" ||
      data.Phonenumber === ""
    ) {
      return setErrorMsg("Please fulfill the form");
    }
    try {
      setMessage("");
      setErrorMsg("");
      setPageLoading(true);

      await auth
        .createUserWithEmailAndPassword(email, password)
        .then(async (credential) => {
          const user = credential.user;

          await user.updateProfile({
            displayName: fullName,
          });
          await fs.collection("users").doc(user.uid).set({
            Email: email,
            Password: password,
            displayName: fullName,
            phoneNumber: data.Phonenumber,
            Address: data.Address,
            Country: data.Country,
            timeStamp: serverTimestamp(),
          });
        })
        .then(() => {
          navigate("/");
        });

      window.location.reload();
    } catch (e) {
      setErrorMsg(e.message);
    }
    setPageLoading(false);
  };

  const handleSignin = async (e) => {
    e.preventDefault();
    try {
      setErrorMsg("");
      setPageLoading(true);

      await auth
        .signInWithEmailAndPassword(email, password)
        .then(() => {
          setAuthed(true);
        })

        .then(() => {
          navigate("/");
        });
    } catch (e) {
      setSignInErrorMsg(e.message);
    }
    setPageLoading(false);
  };
  // !------------
  const handleLogOut = async () => {
    setIsActive(false);
    setErrorMsg("");

    try {
      if (currentUser) {
        await auth.signOut().then(() => navigate("/"));
      }
    } catch {
      setErrorMsg("Failed to log out");
    }
  };
  //
  const forgotPassword = async (e) => {
    e.preventDefault();
    try {
      setSuccedEmailSent("");
      setForgotErrorMsg("");
      setPageLoading(true);
      await auth.sendPasswordResetEmail(email);
      setSuccedEmailSent("Please check your email");
    } catch (e) {
      setForgotErrorMsg(e.message);
    }
    setPageLoading(false);
  };
  const signInWithGoogle = async (e) => {
    e.preventDefault();
    try {
      setMessage("");
      setPageLoading(true);
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider)
        .then(async (result) => {
          const user = result.user;
          await fs.collection("users").doc(user.uid).set({
            Email: user.email,
            Password: "null",
            displayName: user.displayName,
            timeStamp: serverTimestamp(),
          });
        })
        .then(() => {
          navigate("/");
        });
    } catch (e) {
      console.log(e.message);
    }
    setPageLoading(false);
  };

  useEffect(() => {
    auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        fs.collection("CartOf>>" + currentUser.uid).onSnapshot((snapshot) => {
          const newUserProduct = snapshot.docs.map((doc) => ({
            ID: doc.id,
            ...doc.data(),
          }));
          setUserCartProduct(newUserProduct);
        });
      }
    });
  }, []);

  const addToCart = (item) => {
    if (currentUserId !== null) {
      const Product = item;

      Product["qty"] = 1;
      Product["TotalProductPrice"] = Product.qty * Product.price;
      fs.collection("CartOf>>" + currentUser.uid)
        .doc(item.ID)
        .set(Product);
    } else {
      navigate("login");
    }
  };
  const buyNow = (item) => {
    if (currentUserId !== null) {
      const Product = item;

      Product["qty"] = 1;
      Product["TotalProductPrice"] = Product.qty * Product.price;
      fs.collection("CartOf>>" + currentUser.uid)
        .doc(item.ID)
        .set(Product)
        .then(() => {
          navigate("payment");
        });
    } else {
      navigate("login");
    }
  };

  const decreaseQty = (item) => {
    const newProduct = item;
    newProduct.qty = item.qty - 1;
    newProduct.TotalProductPrice = newProduct.qty * newProduct.price;
    if (item.qty >= 1) {
      auth.onAuthStateChanged((currentUser) => {
        if (currentUser) {
          fs.collection("CartOf>>" + currentUser.uid)
            .doc(item.ID)
            .update(newProduct);
        }
      });
    } else {
      removeCart(item);
    }
  };
  //
  const increaseQty = (item) => {
    const newProduct = item;
    newProduct.qty = item.qty + 1;
    newProduct.TotalProductPrice = newProduct.qty * newProduct.price;

    auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        fs.collection("CartOf>>" + currentUser.uid)
          .doc(item.ID)
          .update(newProduct)
          .then(() => {});
      } else {
      }
    });
  };

  const removeCart = (item) => {
    auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        fs.collection("CartOf>>" + currentUser.uid)
          .doc(item.ID)
          .delete()
          .then(() => {});
      }
    });
  };
  const totalPriceArray = userCartProduct.map((item) => {
    return item.TotalProductPrice;
  });

  //
  const qtyArray = userCartProduct.map((item) => {
    return item.qty;
  });

  const reducerOfQty = (accumulator, currentValue) => {
    return accumulator + currentValue;
  };

  const totalQty = qtyArray.reduce(reducerOfQty, 0);
  const totalPrice = totalPriceArray.reduce(reducerOfQty, 0);

  //
  const handleChange = (e) => {
    setChecked(e.target.checked);
    if (isDark) {
      localStorage.setItem("theme-color", "theme-light");
      localStorage.setItem("switch", "false");
      setChecked(false);
      setIsDark(false);
    } else {
      localStorage.setItem("theme-color", "theme-dark");
      localStorage.setItem("switch", "true");
      setChecked(true);
      setIsDark(true);
    }
  };
  useEffect(() => {
    const currentThemeColor = localStorage.getItem("theme-color");
    const currentCheckStatus = localStorage.getItem("switch");

    if (currentThemeColor === "theme-dark" && currentCheckStatus === "true") {
      setIsDark(true);
      setChecked(true);
    } else {
      setChecked(false);
      setIsDark(false);
    }
  }, []);
  const [searchData, setSearchData] = useState([]);
  useEffect(() => {
    const fectSearchingData = async () => {
      firebase
        .firestore()
        .collection("search")
        .onSnapshot(function (querySnapshot) {
          const items = [];
          querySnapshot.forEach(function (doc) {
            items.push({ key: doc.id, ...doc.data() });
          });

          setSearchData(items);
        });
    };
    fectSearchingData();
  }, []);
  const adminKey = {
    key: process.env.REACT_APP_ADMIN_UID,
  };

  useEffect(() => {
    auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        if (currentUser.uid === adminKey.key) {
          setAdmin(true);
          setAuthed(false);
        } else {
          setAuthed(true);
          setAdmin(false);
        }
      } else {
        setAdmin(false);
        setAuthed(false);
      }
    });
  }, []);
  //
  const [usersList, setUsersList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      firebase
        .firestore()
        .collection("users")
        .onSnapshot(function (querySnapshot) {
          const items = [];
          querySnapshot.forEach(function (doc) {
            items.push({ id: doc.id, ...doc.data() });
          });

          setUsersList(items);
        });
    };

    fetchData();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (password !== rePassword) {
      return setErrorMsg("Passwords do not match");
    }
    if (
      email === "" ||
      fullName === "" ||
      password === "" ||
      data.Address === "" ||
      data.Country === "" ||
      data.Phonenumber === ""
    ) {
      return setErrorMsg("Please fulfill the form");
    }
    try {
      setPageLoading(true);
      await updateProfile(auth.currentUser, {
        displayName: fullName,
      });
      await updateEmail(auth.currentUser, email);
      await updatePassword(auth.currentUser, password);
      await fs
        .collection("users")
        .doc(currentUser.uid)
        .set({
          Email: email,
          Password: password,
          displayName: fullName,
          phoneNumber: data.Phonenumber,
          Address: data.Address,
          Country: data.Country,
          timeStamp: serverTimestamp(),
        })
        .then(() => {
          navigate("/");
        });

      window.location.reload();
    } catch (err) {
      setErrorMsg(err);
    }
    setPageLoading(true);
  };
  //
  const handleInputChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;
    setData({ ...data, [id]: value });
  };
  //

  const handleDelete = async (id) => {
    try {
      await auth.currentUser.delete();
      await deleteDoc(doc(db, "users", id));
    } catch (err) {
      console.log(err);
    }
  };

  const value = {
    handleDelete,
    handleAdd,
    handleInputChange,
    usersList,
    admin,
    authed,
    currentUser,
    handleUpdate,
    pageLoading,
    isDark,
    setIsDark,
    //
    searchData,
    currentUserName,
    handleChange,
    checked,
    messsage,
    currentUserId,
    totalPrice,
    totalQty,
    removeCart,
    addToCart,
    buyNow,
    forgotPassword,
    decreaseQty,
    increaseQty,
    userCartProduct,
    errorMsg,
    fullName,
    setFullName,
    isActive,
    setIsActive,
    email,
    setEmail,
    rePassword,
    password,
    setPassword,
    setRePassword,
    succedEmailSent,
    forgotErrorMsg,
    signInErrorMsg,
    handleLogOut,
    handleSignin,
    handleSignup,
    signInWithGoogle,
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}
const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);
const useStateValue = () => useContext(StateContext);
export {
  StateContext,
  StateProvider,
  useStateValue,
  DataContext,
  DataProvider,
};
